<template>
  <div class="case-wrap">
    <!-- <h4 class="title">{{$t('design.case.createRequirement') || '新建需求'}}</h4> -->
    <!-- 步骤条 -->
		<div class="case-step">
      <steps :active="active" :steps="stepsList" @click="jumpToStep"></steps>
		</div>
    <!-- 步骤内容 -->
    <div class="case-content">
      <case-type ref="caseTypeRef" v-show="active === 0" @clear="onClear" @next="onNext"></case-type>
      <case-design ref="caseDesignRef" :info="info" v-show="active === 1"  @pre="onPre" @next="onNext" :activeStep="active"></case-design>
      <case-file ref="caseFileRef" :info="info" v-show="active === 2" @pre="onPre" @next="onNext"></case-file>
      <case-preview ref="casePreRef" :info="info" v-show="active === 3" @pre="onPre" @next="onNext" :activeStep="active"></case-preview>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onUnmounted, onMounted } from 'vue';
import CaseType from './caseType.vue';
import CaseDesign from './caseDesign.vue';
import CaseFile from './caseFile.vue';
import CasePreview from './casePreview.vue';
import { useLang } from "@shining3d/common-module/utils/lang.js";
import Steps from '../../components/steps.vue';
const { $t } = useLang("@shining3d/xl-design-order");
const caseTypeRef = ref(null);
const caseDesignRef = ref(null);
const caseFileRef = ref(null);
const casePreRef = ref(null);

const info = ref({}); // 选择商品需求信息

const active = ref(0);
const stepsList = [{
  title: $t('design.case.selectDesignType') || '选择设计类型'
}, {
  title: $t('design.case.selectDesignRequirement') || '选择设计需求'
}, {
  title: $t('design.case.uploadImageFile') || '上传影像文件'
}, {
  title: $t('design.case.previewSubmission') || '预览提交'
}];

const onClear = () => {
  info.value = {};
  caseDesignRef.value.resetData();
  caseFileRef.value.resetData();
};

const stepIndex = [];
const onNext = ({ data, index }) => {
  const obj = Object.assign({}, info.value, data);
  info.value = obj;
  active.value = active.value + 1;
  stepIndex.value = index;
};

const onPre = () => {
  active.value = active.value - 1;
};

const jumpToStep = ( index ) => {

  const step0Res = caseTypeRef.value.validate().valid;
  const step1Res = caseDesignRef.value.validate().valid;
  const step2Res = caseFileRef.value.validate().valid;
  const validResult = [step0Res, step1Res, step2Res];

  if (validResult.slice(0, index).includes( false )) {
    return;
  }

  // 跳步骤条的时候，需要重新更新下 info 信息
  const step0Value = caseTypeRef.value.getValue();
  const step1Value = caseDesignRef.value.getValue();
  const step2Value = caseFileRef.value.getValue();
  const obj = Object.assign({}, step0Value, step1Value, step2Value );
  info.value = obj;

  active.value = index;
};

onMounted(() => {
  sessionStorage.setItem('detanlDesignChooseGood', '');
});
</script>

<style lang="scss" scoped>
.case-wrap {
  background: #fff;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding-top: 16px;
  // padding-right: 16px;
  box-sizing: border-box;
}
.title {
  font-size: 18px;
  line-height: 25px;
  // margin-bottom: 16px;
  margin-left: 16px;
}
// .case-step {
//   box-sizing: border-box;
//   padding-left: 20px;
//   padding-right: 40px;
//   :deep(.el-step.is-simple .el-step__head) {
//     display: none;
//   }

//   :deep(.el-steps--simple) {
//     background-color: white !important;
//     // padding-top: 0px;
//     // padding-bottom: 0px;
//     padding: 13px 7%;
//     padding-top: 0px;
//   }

//   :deep(.el-step.is-simple .el-step__arrow) {
//     min-width: 80px;
//     &::before {
//       transform: rotate(-50deg) translateY(-1.3px);
//       transform-origin: 0 0;
//       content: '';
//       display: inline-block;
//       position: absolute;
//       height: 5px;
//       width: 1px;
//       background-color: $text-more-color;
//     }
//     &::after {
//       transform: rotate(50deg) translateY(1.3px);
//       transform-origin: 100% 100%;
//       content: '';
//       display: inline-block;
//       position: absolute;
//       height: 5px;
//       width: 1px;
//       background-color: $text-more-color;
//     }
//   }
//   :deep(.el-step.is-simple:not(:last-of-type) .el-step__title) {
//     max-width: inherit;
//   }

//   :deep(.el-step__title) {
//     max-width: inherit;
//     padding: 13px 20px;
//     height: 48px;
//     box-sizing: border-box;
//   }
//   :deep(.el-step__title.is-process) {
//     border-bottom: 2px solid #5587FF;
//   }

//   :deep(.el-step__title.is-process .step-title) {
//     overflow: hidden;
//     // color: $bg-color-step;
//     font-feature-settings: 'clig' off, 'liga' off;
//     text-overflow: ellipsis;
//     font-family: $font-family65;
//     font-size: 14px;
//     font-style: normal;
//     font-weight: normal;
//     line-height: 22px;
//     color: #5587FF;
//     // &::before {
//     //   content: '';
//     //     width: 160px;
//     //     height: 1px;
//     //     position: absolute;
//     //     top: 34px;
//     //     left: -29px;
//     //     background-color: $bg-color-step;
//     // }
//   }

//   :deep(.el-step__title .step-title) {
//     overflow: hidden;
//     color: #42526E;
//     font-feature-settings: 'clig' off, 'liga' off;
//     text-overflow: ellipsis;
//     font-family: $font-family65;
//     font-size: 14px;
//     font-style: normal;
//     font-weight: normal;
//     line-height: 22px;
//   }

//   :deep(.el-step__title.is-process .step-number) {
//     width: 16px;
//     height: 16px;
//     align-self: center;
//     border-radius: 50%;
//     // background-color: $bg-color-step;
//     // color: $text-step-color;
//     text-align: center;
//     font-family: $font-family65;
//     font-size: 12px;
//     font-style: normal;
//     font-weight: 700;
//     line-height: 16px;
//     margin-right: 4px;
//     color: #fff;
//     background-color: #5587FF;
//   }

//   :deep(.el-step__title .step-number) {
//     width: 16px;
//     height: 16px;
//     align-self: center;
//     border-radius: 50%;
//     background-color: #E0E4EA;
//     color: #42526E;
//     text-align: center;
//     font-family: $font-family65;
//     font-size: 12px;
//     font-style: normal;
//     font-weight: 700;
//     line-height: 16px;
//     margin-right: 4px;
//   }
//   :deep(.el-step__title .step-done) {
//     background: url('../../assets/image/step_success.svg');
//     display: flex;
//     align-items: center;
//     justify-content: center;
//   }
//   .jump-step {
//     cursor: pointer;
//   }
//   .step-item {
//     display: flex;
//   }
//   .step-title {
//     // text-align: center;
//     flex: 1;
//     // max-width: 140px;
//     // flex:0 0 135px;
//     white-space: nowrap;
//     overflow: hidden;
//     text-overflow: ellipsis;
//     font-family: $font-family65;
//     font-size: 14px;
//     font-weight: normal;
//     .text-select {
//       background-color: #42526e;
//     }
//     .text-select-default {
//       background-color: #bdc3cd;
//     }
//   }
// }
.case-step {
  padding-left: 16px;
  padding-right: 16px;
  box-sizing: border-box;
  width: 100%;
}
.case-content {
  flex: 1;
  height: 100%;
  overflow: hidden;
}
</style>